import { render, staticRenderFns } from "./CongressesList.vue?vue&type=template&id=03554990"
import script from "./CongressesList.vue?vue&type=script&lang=js"
export * from "./CongressesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports